<template>
    <div v-if="until.Days >= 0" class="-mt-1 flex justify-center">
        <div v-for="(num, label) in until" :key="`countdown-${label}`" class="flex items-center gap-x-1 border-l-2 border-white px-2.5 first:border-0 sm:gap-x-1.5 md:px-4.5">
            <span class="text-blue-dark text-3xl leading-none sm:text-4xl md:text-5xl">{{ num }}</span>
            <span class="font-modesto-cond pt-1 text-sm leading-none uppercase sm:text-base md:text-lg">{{ label }}</span>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { DateTime } from 'luxon';

const props = defineProps({ end: { type: String, required: true } });

const dtEnd = ref(DateTime.fromISO(props.end + 'T00:00:00-15:00'));
const untilRef = ref(calcUntil());

const until = computed(() => {
    return {
        Days: parseInt(untilRef.value.days),
        Hours: parseInt(untilRef.value.hours),
        Minutes: parseInt(untilRef.value.minutes),
    };
});

/**
 * Calculate the difference.
 *
 * @returns {object} Time difference represented as an object.
 */
function calcUntil() {
    const start = DateTime.now().setZone('America/Chicago');

    return dtEnd.value.diff(start, ['days', 'hours', 'minutes']).toObject();
}

setInterval(() => (untilRef.value = calcUntil()), 5000);
</script>
